import { Action, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';

import { catchError, tap } from 'rxjs';

import { inject, Injectable } from '@angular/core';

import { handleSectionError } from '@osf/shared/helpers/state-error.handler';
import { Institution } from '@osf/shared/models/institutions/institutions.model';
import { InstitutionsService } from '@osf/shared/services/institutions.service';

import { FetchInstitutionById } from './institutions-search.actions';
import { INSTITUTIONS_SEARCH_STATE_DEFAULTS, InstitutionsSearchStateModel } from './institutions-search.model';

@State<InstitutionsSearchStateModel>({
  name: 'institutionsSearch',
  defaults: INSTITUTIONS_SEARCH_STATE_DEFAULTS,
})
@Injectable()
export class InstitutionsSearchState {
  private readonly institutionsService = inject(InstitutionsService);

  @Action(FetchInstitutionById)
  fetchInstitutionById(ctx: StateContext<InstitutionsSearchStateModel>, action: FetchInstitutionById) {
    ctx.patchState({ institution: { data: {} as Institution, isLoading: true, error: null } });

    return this.institutionsService.getInstitutionById(action.institutionId).pipe(
      tap((response) => {
        ctx.setState(
          patch({
            institution: patch({ data: response, error: null, isLoading: false }),
          })
        );
      }),
      catchError((error) => handleSectionError(ctx, 'institution', error))
    );
  }
}
